import { Box } from '@mui/material';
import React from 'react';

export interface ViewVacancySkillOrTechnologyProps {
  title: string;
  primary: { name: string; yearsOfExperience: number }[];
  secondary: { name: string; yearsOfExperience: number }[];
}

const skillTagColors = [
  { background: '#E9584526', color: '#E95845' }, // First skill (red)
  { background: '#5F8CFF1A', color: '#5F8CFF' }, // Others (blue)
];

const yearsTagStyle = {
  color: '#A259FF',
  fontWeight: 500,
  fontSize: '13.5px',
  display: 'inline-block',
  fontFamily: 'Inter',
  marginLeft: '4px',
};

const ViewVacancySkillOrTechnologyCard: React.FC<ViewVacancySkillOrTechnologyProps> = ({ title, primary, secondary }) => {
  const allSkills = [
    ...primary.map((s) => ({ ...s, type: 'primary' })),
    ...secondary.map((s) => ({ ...s, type: 'secondary' })),
  ];

  return (
    <Box className="view-vacancy-section" sx={{ mb: 2 }}>
      <div className="skill-technology-title">
        {title}
      </div>
      {allSkills.length > 0 && <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {allSkills.map((skill, idx) => {
          const colorIdx = idx === 0 ? 0 : 1;
          return (
            <Box
              key={skill.name + skill.yearsOfExperience}
              className="skill-technology-tag"
              style={{
                background: skillTagColors[colorIdx].background,
                color: skillTagColors[colorIdx].color,
              }}>
              {skill.name}
              <span style={yearsTagStyle}>. {skill.yearsOfExperience} {skill.yearsOfExperience > 1 ? 'Years' : 'Year'}</span>
            </Box>
          );
        })}
      </Box>}
    </Box>
  );
};

export default ViewVacancySkillOrTechnologyCard; 